/**
 * @file RefreshButton.jsx
 * Pulsante "Aggiorna" riutilizzabile per ricaricare i dati di una pagina o di un pannello.
 * Se onClick restituisce una Promise, il pulsante resta disabilitato finché non termina.
 *
 * Props:
 *   onClick   — callback da eseguire al click (anche async)
 *   label     — testo del pulsante (default "Aggiorna")
 *   title     — tooltip
 *   size      — "md" (default) | "sm" per le toolbar compatte
 *   disabled  — disabilita il pulsante dall'esterno
 */
import { useState } from 'react';

const SIZES = {
  md: 'px-4 py-2 rounded-xl text-sm',
  sm: 'px-2.5 py-1.5 rounded-md text-xs md:text-sm',
};

export default function RefreshButton({ onClick, label = 'Aggiorna', title, size = 'md', disabled = false }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick?.();
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled || loading}
      title={title}
      className={`${SIZES[size]} bg-card-inner border border-line text-ink font-medium hover:bg-card transition-colors shadow-sm whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed`}
    >
      {label}
    </button>
  );
}
